export default "__VITE_ASSET__gQss$hpx__"